import React from 'react';

function CallButton({ text, phoneNumber }) {
	return (
		<div className=''>
			<a href={`tel:${phoneNumber}`} className="">
				{text}<span className='font-bold'>{phoneNumber}</span>
			</a>
		</div>
	);
}

export default CallButton;